import script from "./NurseView.vue?vue&type=script&lang=ts&setup=true"
export * from "./NurseView.vue?vue&type=script&lang=ts&setup=true"

import "./NurseView.vue?vue&type=style&index=0&id=6efedaec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6efedaec"]])

export default __exports__